module.exports = __webpack_public_path__ + "img/star-map_backgrounds-black_and_gold.a13c43a.webp";